import { fulfillmentTransactionBeforeSave } from "services/sosInventoryService/fulfillmentTransaction/beforeSave";

import { OBJECT_TYPES } from "appConstants";

export function beforeSave(record) {
  const newRecord = fulfillmentTransactionBeforeSave(
    OBJECT_TYPES.SHIPMENT.fullString,
    record
  );

  return newRecord;
}
